import React, { useState } from 'react'
import FormContainer from '../components/FormContainer'
import { Form, Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { updatePasswordRequest } from '../redux/actions/userActions'

const ResetPasswordScreen = () => {
  const [password, setPassword] = useState('')
  const [updated, setupdated] = useState(false)

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const key = searchParams.get('key')

  const dispatch = useDispatch()

  const submitHandler = (e) => {
    e.preventDefault()
    if (key) {
      dispatch(updatePasswordRequest(password, key))
      setupdated(true)
    }
  }

  return (
    <FormContainer>
      <h1>Reset Password</h1>
      {updated ? (
        <p>
          Your password has been reset successfully. You can now log in with
          your new password.
        </p>
      ) : (
        <Form onSubmit={submitHandler}>
          <Form.Group controlId='email'>
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type='password'
              placeholder='New password'
              onChange={(e) => setPassword(e.target.value)}
              required
            ></Form.Control>
          </Form.Group>
          <Button type='submit' variant='primary'>
            Update
          </Button>
        </Form>
      )}
    </FormContainer>
  )
}

export default ResetPasswordScreen
